import Table from "react-bootstrap/Table";

import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { timeToString } from "@/utils/dateUtil";

type Props = {
	aggregatedByRiskClassification: ResumeGrouped<RiskClassification, object>[];
	averageWaitTimeInSecondsByRiskClassification: ResumeGrouped<RiskClassification, object>[];
};

export function AverageWaitingForRisckClassificationTable({
	aggregatedByRiskClassification,
	averageWaitTimeInSecondsByRiskClassification,
}: Props) {
	return (
		<Table className="text-center" responsive striped bordered hover>
			<thead>
				<tr className="fw-bolder">
					<th className="pe-2 text-start">Classificação</th>
					<th>Quantidade</th>
					<th className="pe-2">Tempo médio</th>
				</tr>
			</thead>
			<tbody>
				{aggregatedByRiskClassification.map((aggregated, index) => (
					<tr key={`wait-time-risk-classification-table-row-${index}`}>
						<td className="ps-2 text-start">
							<span
								style={{
									color: aggregated.key?.color || "#6c757d",
									fontWeight: "bold",
								}}
							>
								{aggregated.key?.name || "Não informado"}
							</span>
						</td>
						<td>{aggregated.total}</td>
						<td className="pe-2">
							{timeToString(
								averageWaitTimeInSecondsByRiskClassification.find(
									(waitTimeAggregated) =>
										waitTimeAggregated.key?.id === aggregated.key?.id
								)?.total || 0
							)}
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
